import React from 'react'

export default function Logo({ linkComponent, authenticated }) {
  const LinkComponent = linkComponent
  const href = authenticated ? '/home/dashboard' : '/'
  return (
    <LinkComponent href={href} title='Go to homepage' className='header__logo'>
      Logo
    </LinkComponent>
  )
}
